module.exports = __webpack_public_path__ + "img/IMG_1853.86507e70.jpg";